import React from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import translate from '../../../commonComponents/translate';
import List from '../../../commonComponents/lists/ClientSideList';
import UserColumn from '../../../commonComponents/lists/columns/UserColumn';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import { newFormatPrice } from '../../../services/utilityFunctions';

const TYPE = {
  BEGINNER_PACK: 'Beginner Pack',
  PLAYER_PACK: 'Player Pack',
  PACK_PERFORMER: 'Pack Performer',
};

const WeelodgeAgentsInfo = ({ agencyCommission, agencyCommissionCurrency, sellers, finders, sparringProgram, t }) => {
  const tableId = 'agentsInfo';

  const sparringPrograms = type => {
    switch (type) {
      case TYPE.BEGINNER_PACK:
        return t('commissions.userCommissions.sparring_program.beginner_pack');
      case TYPE.PLAYER_PACK:
        return t('commissions.userCommissions.sparring_program.player_pack');
      case TYPE.PACK_PERFORMER:
        return t('commissions.userCommissions.sparring_program.pack_performer');
      default:
        return type;
    }
  };
  const handleAgentsInfo = (commission, agents, program, type) => agents.map(s => {
    const user = s;
    user.type = t(type);
    const prog = program.find(p => p && p.email === s.email);
    if (prog) {
      user.sparringProgram = sparringPrograms(prog.packType);
    }
    user.userCommission = (commission / 2) * (user.commissionPercentage * 0.01);
    return user;
  });
  const handleAgents = (commission, agentsSellers = [], agentsFinders = [], programs = []) => [
    ...handleAgentsInfo(commission, agentsSellers, programs, 'commissions.userCommissions.seller'),
    ...handleAgentsInfo(commission, agentsFinders, programs, 'commissions.userCommissions.finder'),
  ];

  const renderUser = (name, image) => {
    let user = null;
    if (name) {
      user = { username: name };
    }
    if (image) {
      user = { ...user, image };
    }
    return renderToStaticMarkup(
      <>
        {user ?
          (<UserColumn t={t} user={user} smallFormat />)
          :
          '-'
        }
      </>,
    );
  };

  const columns = [
    {
      field: 'type',
      title: t('commissions.userCommissions.pack_type'),
      textAlign: 'left',
      sortable: false,
      template: ({ type }) => renderToStaticMarkup(
        <span>
          {type}
        </span>,
      ),
    },
    {
      field: 'name',
      title: t('name'),
      textAlign: 'left',
      sortable: false,
      template: ({ name, image }) => renderUser(name, image),
    },
    {
      field: 'email',
      textAlign: 'left',
      title: t('email'),
      sortable: false,
      template: ({ email }) => renderToStaticMarkup(
        <span>
          {email}
        </span>,
      ),
    },
    {
      field: 'subscriptionPack',
      textAlign: 'left',
      title: t('commissions.userCommissions.subscription_pack'),
      sortable: false,
      template: ({ subscriptionPack }) => renderToStaticMarkup(
        <span>
          {subscriptionPack}
        </span>,
      ),
    },
    {
      field: 'sparringProgram',
      textAlign: 'left',
      title: t('commissions.userCommissions.sparring_program'),
      sortable: false,
      template: ({ sparringProgram: program }) => renderToStaticMarkup(
        <span>
          {program}
        </span>,
      ),
    },
    {
      field: 'userCommission',
      textAlign: 'center',
      title: t('commissions.userCommissions.userCommission'),
      sortable: false,
      template: ({ userCommission }) => renderToStaticMarkup(
        <span>
          {newFormatPrice(userCommission, true, agencyCommissionCurrency || 'EUR')}
        </span>,
      ),
    },
    {
      field: 'commissionPerRange',
      textAlign: 'center',
      title: t('commissions.userCommissions.commissionPerRange'),
      sortable: false,
      template: ({ commissionPerRange = [] }) => renderToStaticMarkup(
        <div>
          {commissionPerRange
            .filter(r => r.amount > 0)
            .map(r => `${newFormatPrice(r.amount, true, agencyCommissionCurrency || 'EUR')} (${(r.percentage * 100)}%)`)
            .join(';\n')}
        </div>,
      ),
    },
  ];
  return (
    <div>
      <List
        id={tableId}
        loading={false}
        data={handleAgents(agencyCommission, sellers, finders, sparringProgram)}
        columns={columns}
        pagination={false}
      />
      <div className="ongoing-warning">
        <span>{t('weelodge.modal.on_going_warning')}</span>
      </div>
    </div>
  );
};

WeelodgeAgentsInfo.propTypes = {
  t: PropTypes.func.isRequired,
  agencyCommission: PropTypes.number.isRequired,
  agencyCommissionCurrency: PropTypes.string.isRequired,
  sellers: PropTypes.arrayOf(PropTypes.shape({
    image: ImageProp.propType,
    name: PropTypes.string,
    userId: PropTypes.string,
    subscriptionPack: PropTypes.string,
    email: PropTypes.string,
  })).isRequired,
  finders: PropTypes.arrayOf(PropTypes.shape({
    image: ImageProp.propType,
    name: PropTypes.string,
    userId: PropTypes.string,
    subscriptionPack: PropTypes.string,
    email: PropTypes.string,
  })).isRequired,
  sparringProgram: PropTypes.arrayOf(PropTypes.shape({
    packType: PropTypes.string,
    subscriptionDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    email: PropTypes.string,
  })).isRequired,
};

export default translate(WeelodgeAgentsInfo);
